import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, fontSize, lineHeight } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Text = styled(Box).withConfig({
  componentId: "hv6g11-0"
})(["color:", ";font-size:", ";line-height:", ";"], function (_ref) {
  var contrast = _ref.contrast;
  return contrast ? color("text." + contrast) : "inherit";
}, function (_ref2) {
  var size = _ref2.size;
  return size && fontSize(size);
}, function (_ref3) {
  var size = _ref3.size;
  return size && lineHeight(size);
});
Text.displayName = "Text";
Text.defaultProps = {
  size: "md",
  as: "span"
};
export { Text };